export default __webpack_public_path__ + "static/media/coronado.566a5ab4.jpeg";